import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PatientProfile from './PatientProfile';
import usePatientSetupEffects from './usePatientSetupEffects';
const PatientSetup = ({ enrollCode, invitationCode, externalReturnUrl })=>{
    usePatientSetupEffects(externalReturnUrl);
    return /*#__PURE__*/ _jsx(PatientProfile, {
        enrollCode: enrollCode,
        invitationCode: invitationCode
    });
};
export default PatientSetup;
